import React, { useState, useRef } from "react";
import moment from "moment-timezone";
import _ from "lodash";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import Select from "react-select";
import LookupTreeView from "./LookupTreeView";
import { useEffect } from "react";

function OptionSelector(props) {
  const lookupView = useRef(LookupTreeView);
  const [lookupVisible, setLookupVisible] = useState(props.visible || false);
  const [lookupSelectedItems, setLookupSelectedItems] = useState([]);
  // useEffect(() => {
  //   if (props.optionsChanged) {
  //     props.optionsChanged(e);
  //   }
  // }, [lookupSelectedItems]);
  return (
    <>
      <div className='col-12 col-sm-4'>
        <div className='card card-primary card-outline card-tabs'>
          <div className='card-header p-0 pt-1 border-bottom-0'>
            <ul className='nav nav-tabs' id='durations-tab' role='tablist'>
              {props.optionSet &&
                props.optionSet.map((optionHead, idx) => {
                  return (
                    <>
                      <li key={idx} className='nav-item'>
                        <a
                          className={idx == 0 ? "nav-link active" : "nav-link"}
                          id={`${optionHead.key}-tab`}
                          data-toggle='pill'
                          href={`#${optionHead.key}`}
                          role='tab'
                          aria-controls={optionHead.key}
                          aria-selected='true'
                        >
                          {optionHead.label}
                        </a>
                      </li>
                    </>
                  );
                })}
            </ul>
          </div>
          <div className='card-body'>
            <div className='tab-content' id='durations-tabContent'>
              {props.optionSet &&
                props.optionSet.map((optionHead, idx) => {
                  return (
                    <>
                      <div
                        key={idx}
                        className={
                          idx == 0
                            ? "tab-pane fade show active"
                            : "tab-pane fade show"
                        }
                        id={optionHead.key}
                        role='tabpanel'
                        aria-labelledby={`${optionHead.key}-tab`}
                      >
                        <div className='form-group'>
                          {optionHead?.attributes?.map((attribute, idx) => {
                            switch (attribute.type) {
                              case "lookup":
                                return (
                                  <div>
                                    <a
                                      href='#'
                                      onClick={() => {
                                        lookupView?.current?.setTitle(
                                          attribute.label
                                        );
                                        lookupView?.current?.setDataSource(
                                          attribute.dataSource
                                        );
                                        lookupView?.current?.setLeafPrefix(
                                          attribute.leafPrefix
                                        );
                                        setLookupVisible(true);
                                      }}
                                    >
                                      {lookupSelectedItems &&
                                      lookupSelectedItems.length > 0
                                        ? `${_.slice(
                                            lookupSelectedItems,
                                            0,
                                            attribute.maxItemsToCompact
                                          )
                                            .reduce((aggregator, device) => {
                                              return (
                                                aggregator + ` ${device?.name},`
                                              );
                                            }, "")
                                            .slice(0, -1)} ${
                                            lookupSelectedItems.length >
                                            attribute.maxItemsToCompact
                                              ? ` + ${
                                                  lookupSelectedItems.length -
                                                  attribute.maxItemsToCompact
                                                } more...`
                                              : ``
                                          }`
                                        : `Select Devices`}
                                    </a>
                                  </div>
                                );
                              case "select":
                                return (
                                  <>
                                    <div className='form-group' key={idx}>
                                      {attribute?.label && (
                                        <label>{attribute.label}</label>
                                      )}
                                      <Select
                                        isLoading={attribute.isLoading}
                                        options={attribute.options}
                                        value = {attribute.selected}
                                        onChange={(e) => {
                                          props.optionsChanged(
                                            e.value,
                                            attribute.parameter,
                                            e
                                          );
                                        }}
                                      ></Select>
                                    </div>
                                  </>
                                );
                              case "daterange":
                              case "singledate":
                                return (
                                  <>
                                    <div>
                                      <div className='form-group'>
                                        <div className='input-group'>
                                          <div className='input-group-prepend'>
                                            <span className='input-group-text'>
                                              <i className='far fa-clock' />
                                            </span>
                                          </div>
                                          <DateRangePicker
                                            initialSettings={
                                              attribute.type === "daterange"
                                                ? {
                                                    startDate: new Date(
                                                      new Date().setDate(
                                                        new Date().getDate() - 7
                                                      )
                                                    ),
                                                    endDate: new Date(),
                                                    minDate: new Date(
                                                      new Date().setYear(
                                                        new Date().getFullYear() -
                                                          1
                                                      )
                                                    ),
                                                    maxDate: new Date(),
                                                  }
                                                : {
                                                    singleDatePicker: true,
                                                    showDropdowns: true,
                                                    startDate: new Date(),
                                                    endDate: new Date(),
                                                    minDate: new Date(
                                                      new Date().setYear(
                                                        new Date().getFullYear() -
                                                          1
                                                      )
                                                    ),
                                                    maxDate: new Date(),
                                                    minYear:
                                                      new Date().getFullYear() -
                                                      1,
                                                    maxYear:
                                                      new Date().getFullYear(),
                                                  }
                                            }
                                            onApply={(e) => {
                                              props.optionsChanged(
                                                e.target.value,
                                                attribute.parameter,
                                                e
                                              );
                                            }}
                                          >
                                            <input
                                              type='text'
                                              className='form-control float-right'
                                              id='reservationtime'
                                              onChange={(e) => {
                                                props.optionsChanged(
                                                  e.value,
                                                  attribute.parameter,
                                                  e
                                                );
                                              }}
                                            />
                                          </DateRangePicker>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              default:
                                break;
                            }
                          })}
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <LookupTreeView
        ref={lookupView}
        visible={lookupVisible}
        onHide={() => {
          setLookupVisible(false);
        }}
        onSelected={(e) => {
          props.optionsChanged(e, "device", e);
          setLookupSelectedItems(e);
        }}
      ></LookupTreeView>
    </>
  );
}

export { OptionSelector };
